import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { map } from 'rxjs/operators';

@Injectable()
export class AccountsResolver implements Resolve<any> {
  constructor(
    private routerService: Router,
    private authService: AuthService,
  ) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    return this.authService.accessLevel$.pipe(
      map(
      (res: any) => {
        if (res.error) {
          if (res.error.code === 19) {
            this.authService.clearTokenNavigate('login');
          } else {
            this.routerService.navigate(['/404']);
          }
          return false;
        }
        if (res === 'system' || res === 'account') {
          return true;
        }
        this.routerService.navigate(['/404']);
        return false;
      }));
  }
}
